import * as React from 'react'

export interface Params {
  onChange?: () => void
  onBlur?: () => void
  loading: boolean
  completed: boolean
}

interface Props {
  onSubmit: () => void
  isSelect?: boolean
}

const AutoSaveInput: React.FC<Props & React.ConsumerProps<Params>> = ({
  children,
  onSubmit,
  isSelect,
}) => {
  const [loading, setLoading] = React.useState(false)
  const [completed, setCompleted] = React.useState(false)

  const submit = React.useCallback(async () => {
    setLoading(true)
    await onSubmit()
    setLoading(false)
    setCompleted(true)

    window.setTimeout(() => {
      setCompleted(false)
    }, 1000)
  }, [onSubmit])

  const baseProps = {
    loading,
    completed,
  }

  const callbackProp = isSelect
    ? {
        onChange: submit,
      }
    : {
        onBlur: submit,
      }

  return children({ ...baseProps, ...callbackProp })
}

export default AutoSaveInput
